var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper_main"},[_c('main',{staticClass:"content"},[_c('div',{staticClass:"map",staticStyle:{"max-height":"388px","border-radius":"var(--border-radius-7)","overflow":"hidden"}},[_c('div',{staticStyle:{"width":"100%","height":"410px"},attrs:{"id":"map"}})])])])
}]

export { render, staticRenderFns }